import React from 'react';
import { avatarRotationForVisualSeat } from '../utils/tableSeats';
import AvatarBadgeChip from './AvatarBadgeChip';

function SeatAvatar({
  occupant,
  visualSeat,
  isYou,
  size = 56,
  showHost = false,
  showDealer = false,
}) {
  const rotateEnabled = occupant?.avatarRotate !== false;
  const rotation = (!isYou && rotateEnabled)
    ? avatarRotationForVisualSeat(visualSeat)
    : 0;
  const url = occupant?.avatarUrl;
  const label = occupant?.username || occupant?.botLabel || '?';
  const isBot = occupant?.type === 'site_bot' || occupant?.type === 'external_bot';

  const avatarEl = !url ? (
    <span
      className={[
        'seat-avatar',
        'seat-avatar--placeholder',
        isYou ? 'seat-avatar--you' : '',
        isBot ? 'seat-avatar--bot' : '',
      ].filter(Boolean).join(' ')}
      style={{ width: size, height: size }}
      title={label}
    >
      {isBot ? 'B' : label.charAt(0).toUpperCase()}
    </span>
  ) : (
    <img
      src={url}
      alt=""
      className={[
        'seat-avatar',
        isYou ? 'seat-avatar--you' : '',
        isBot ? 'seat-avatar--bot' : '',
      ].filter(Boolean).join(' ')}
      style={{
        width: size,
        height: size,
        transform: rotation ? `rotate(${rotation}deg)` : undefined,
      }}
      title={label}
    />
  );

  if (!showHost && !showDealer) return avatarEl;

  return (
    <span className="seat-avatar-wrap" style={{ width: size, height: size }}>
      {avatarEl}
      {showHost && <AvatarBadgeChip kind="host" />}
      {showDealer && <AvatarBadgeChip kind="dealer" />}
    </span>
  );
}

export default SeatAvatar;